export class Controller {

    /** @ngInject */
    constructor($rootScope, $scope, $state) {
        this.$rootScope = $rootScope;
        this.$state = $state;
    }

    $onInit() {
        this.isSaml =
            this.$state.is('public.login-saml-with-app-id') ||
            this.$state.is('public.login-saml-with-req-link');
        this.isOldLogin =
            this.$state.is('public.old-login') ||
            this.$state.is('public.old-login-with-app-id');

        this.$rootScope.queryString = window.location.href.split('?')[1];
        // Saaspass Connect | OIDC Client login request check
        this.$rootScope.isSaaspassConnectLogin = false;
        this.$rootScope.isOidcClientLogin = false;
        this.$rootScope.oauthClientId = null;
        this.$rootScope.ilEnabled = true;    
        this.$rootScope.plEnabled = true;   
        var type = this.$state.params.type;
        if (type != null) {
            this.$rootScope.clientDisplayName = this.$state.params.client;
            if (type == 'saaspassConnect') {
                this.$rootScope.isSaaspassConnectLogin = true;
            } else if (type == 'oidcClient') {
                this.$rootScope.isOidcClientLogin = true;
                this.$rootScope.ilEnabled = this.$state.params.ilenabled != 'false';
                this.$rootScope.plEnabled = this.$state.params.plenabled != 'false';
                let continueParam = this.$state.params.continue;
                if (continueParam != null) {
                    const url = new URL(continueParam);
                    const searchParams = url.searchParams;
                    this.$rootScope.oauthClientId = searchParams.get('client_id');
                }
            }
        }
    }

    switchOldRegularLogin() {
        this.$rootScope.authenticationError = false;
        this.$rootScope.captchaError = false;
        localStorage.setItem('loginAttempts', '0');

        if (this.$state.is('public.old-login-with-app-id')) {
            this.$state.go('public.login-web-saml', this.$state.params);
        } else if (this.$state.is('public.login-web-saml')) {
            this.$state.go('public.old-login-with-app-id', this.$state.params);
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/public.controller.js